import Const from 'constants';
import {BaseAction} from 'actions';

let RandomTeamStacking = {
    useStacking(use) {
        return {
            type: Const.RANDOM_TEAM_STACKING_IS_USED,
            use,
        };
    },

    useDisallowedPositions(useOption) {
        return {
            type: Const.RANDOM_TEAM_STACKING_SET_DISALLOWED_POSITIONS_IS_USED,
            useOption,
        };
    },

    setDisallowedPositions(groupNumber, positions) {
        return {
            type: Const.RANDOM_TEAM_STACKING_SET_DISALLOWED_POSITIONS,
            groupNumber,
            positions,
        };
    },

    setPlayersQuantityForGroupNumber(playersQuantity, groupNumber) {
        return {
            type: Const.RANDOM_TEAM_STACKING_SET_PLAYERS_QUANTITY,
            playersQuantity,
            groupNumber,
        };
    },

    setTeamsAreChosenRandomly(chooseTeamsRandomly) {
        return {
            type: Const.RANDOM_TEAM_STACKING_SET_TEAMS_ARE_CHOSEN_RANDOMLY,
            chooseTeamsRandomly,
        };
    },

    setCaptainIsForced(forceCaptain) {
        return {
            type: Const.RANDOM_TEAM_STACKING_SET_CAPTAIN_IS_FORCED,
            forceCaptain,
        };
    },

    setStackTeamsIsChecked(checked) {
        return {
            type: Const.RANDOM_TEAM_STACKING_SET_STACK_TEAMS_IS_CHECKED,
            checked,
        };
    },

    setStackTeamsExposure(exposure) {
        return {
            type: Const.RANDOM_TEAM_STACKING_SET_STACK_TEAMS_EXPOSURE,
            exposure,
        };
    },

    setTeams(teams) {
        return {
            type: Const.RANDOM_TEAM_STACKING_SET_TEAMS,
            teams,
        };
    },

    setTeamIsChecked(team, checked) {
        return {
            type: Const.RANDOM_TEAM_STACKING_SET_TEAM_IS_CHECKED,
            team,
            checked,
        };
    },

    setTeamExposure(team, exposure) {
        return {
            type: Const.RANDOM_TEAM_STACKING_SET_TEAM_EXPOSURE,
            team,
            exposure,
        };
    },
};

export default {...BaseAction, ...RandomTeamStacking};
